import { render, staticRenderFns } from "./HomePoster.vue?vue&type=template&id=5d068dca&scoped=true&"
import script from "./HomePoster.vue?vue&type=script&lang=ts&"
export * from "./HomePoster.vue?vue&type=script&lang=ts&"
import style0 from "./HomePoster.vue?vue&type=style&index=0&id=5d068dca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d068dca",
  null
  
)

export default component.exports